import React from 'react'
import { useTranslation } from 'react-i18next'
import type { DoneStatsProps } from './DoneStats.types'
import './DoneStats.scss'

/**
 * Die drei Zahlen über **Geschafft** (CONTEXT.md): heute, diese Woche, Serie.
 *
 * Alle drei zählen nur ihren Lebensbereich (ADR 0020). Die **Serie** wird nie
 * als Verlust gezeigt: Bei null bleibt ihre Kachel leer, statt „0 Tage" zu
 * behaupten — kein Satz kommentiert das Reißen.
 *
 * @example
 * <DoneStats today={5} week={23} streak={6} />
 */
export const DoneStats: React.FC<DoneStatsProps> = ({ today, week, streak }) => {
  const { t } = useTranslation()
  return (
    <dl className="done-stats" aria-label={t('done.stats.label')}>
      <div className="done-stats__tile">
        <dd className="done-stats__value">{today}</dd>
        <dt className="done-stats__caption">{t('done.stats.today')}</dt>
      </div>
      <div className="done-stats__tile">
        <dd className="done-stats__value">{week}</dd>
        <dt className="done-stats__caption">{t('done.stats.week')}</dt>
      </div>
      <div className={`done-stats__tile${streak === 0 ? ' done-stats__tile--empty' : ''}`}>
        <dd className="done-stats__value" data-testid="done-stats-streak">
          {streak > 0 ? streak : ''}
        </dd>
        <dt className="done-stats__caption">
          {streak > 0 ? t('done.stats.streak', { count: streak }) : t('done.stats.streakEmpty')}
        </dt>
      </div>
    </dl>
  )
}
